//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'fullScreenVideo',
    data () {
        return {
            
        }
    },
    methods: {
        goBack () {
            this.$router.go(-1)
        }
    },
    created () {
        
    },
    mounted () {
        this.$nextTick(() => {
            var vdo = document.getElementById("fullScreenVideo");
            vdo.play();
        })
    }
}



// WEBPACK FOOTER //
// ./src/views/fullScreenVideo/fullScreenVideo.vue